var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlayCircleCarlos = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#1d1d1b;opacity:0.15;}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-3{fill:#fff;}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.5,
    cy: 10.5,
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.5,
    cy: 10.5,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.3,14.4,14,10.9a.5.5,0,0,0,.1-.7l-.1-.1L9.3,6.6a.5.5,0,0,0-.7.1.54.54,0,0,0-.1.3v7a.5.5,0,0,0,.5.5A.54.54,0,0,0,9.3,14.4Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayCircleCarlos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play_circle_carlos.fa1ea1aa.svg";
export { ForwardRef as ReactComponent };